<template>
  <div style=" background-color:transparent">
    <v-layout class="hidden-sm-and-down">
      <v-flex xs4>
        <div
          class="pa-3"
          style="width: 100%;
    height: 100%;
    display: table;
    text-align:justify"
        >
          <p class="artefactDescription" v-html="gLang[lang].home.quoteFavourites"></p>
        </div>
      </v-flex>

      <v-flex xs8 class="mb-3 mt-3">
        <v-list class three-line style="background-color:#FAFAFA; border:1px solid #efefef">
          <template>
            <swiper class="pa-2" :options="swiperOption">
              <swiper-slide v-for="artefact in artefacts.slice(0,10)" :key="artefact._id">
                <v-list-tile avatar @click="toArtefact(artefact._id)">
                  <v-list-tile-avatar>
                    <img v-bind:src="artefact.mainImg[0].url + '_profile'">
                  </v-list-tile-avatar>
                  <v-list-tile-content
                    class="collection-list-ie"
                    style="border-bottom:1px solid #efefef"
                  >
                    <v-list-tile-title v-html="artefact.title[lang]"></v-list-tile-title>
                    <v-list-tile-sub-title
                      v-for="user in users"
                      :key="user._id"
                      v-if="(artefact.userId.indexOf(user._id) > -1)"
                      v-html="user.displayName + ' - ' + artefact.description[lang] "
                    ></v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </swiper-slide>

              <div style class="swiper-pagination" slot="pagination"></div>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </template>
        </v-list>
      </v-flex>
    </v-layout>

    <div class="hidden-md-and-up">
      <v-layout>
        <v-flex xs12>
          <div
            class="pa-3"
            style="width: 100%;
    height: 100%;
    display: table;
    text-align:justify"
          >
            <p class="artefactDescription" v-html="previewArtefact"></p>
          </div>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex xs12 class="mb-3 mt-3">
          <v-list class three-line style="background-color:#FAFAFA; border:1px solid #efefef">
            <template>
              <swiper class :options="swiperOption1">
                <swiper-slide v-for="artefact in artefacts.slice(0,10)" :key="artefact._id">
                  <v-list-tile avatar @click="toArtefact(artefact._id)">
                    <v-list-tile-avatar>
                      <img v-bind:src="artefact.mainImg[0].url + '_profile'">
                    </v-list-tile-avatar>
                    <v-list-tile-content
                      class="collection-list-ie"
                      style="border-bottom:1px solid #efefef"
                    >
                      <v-list-tile-title v-html="artefact.title[lang]"></v-list-tile-title>
                      <v-list-tile-sub-title
                        v-for="user in users"
                        :key="user._id"
                        v-if="(artefact.userId.indexOf(user._id) > -1)"
                        v-html="user.displayName + ' - ' + artefact.description[lang] "
                      ></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </swiper-slide>

                <div style class="swiper-pagination" slot="pagination"></div>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
              </swiper>
            </template>
          </v-list>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>


<script>
import "@/../static/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  data() {
    return {
      previewArtefact: "",
      swiperOption: {
        slidesPerView: 2,
        slidesPerColumn: 2,
        spaceBetween: 10,

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      swiperOption1: {
        slidesPerView: 1,
        slidesPerColumn: 2,
        spaceBetween: 10,

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    lang() {
      return this.$store.getters.loadLang;
    },
    artefacts() {
      return this.$store.getters.getFavoriteArtefacts;
    },
    users() {
      return this.$store.getters.loadUsers;
    }
    //  previewArtefact() {
    //   return this.artefacts[0].description;
    // },
  },
  methods: {
    toArtefact(artefactID) {
      this.$router.push("/artefacts/" + artefactID);
    }
  }
  // methods : {
  //   firstDescription () {
  //     this.previewArtefact = this.artefacts[0].description;
  //   }
  // },
  // mounted () {
  //   this.firstDescription();
  // }
};
</script>

<style src='@/../static/swiper.css'>
</style>


<style scoped>
.collection-list-ie {
  display: inline;
}
.swiper-container {
  height: auto !important;
  margin-left: auto;
  margin-right: auto;
}
.swiper-slide {
  height: auto;
}

.swiper-button-next {
  z-index: 9999;
}
.artefactDescription {
  display: table-cell;
  vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// src/components/Partials/ListSwiper.vue